import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/airbend/airbend/src/layouts/page/index.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Header = makeShortcode("Header");
const Contact = makeShortcode("Contact");
const ConferencesComponent = makeShortcode("ConferencesComponent");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Header image="contact" size="30" mdxType="Header" />
    <Contact title="Contact us" subtitle="We support you with your individual solution. Talk to us." addressLabel="How to find us" contactLabel="How to reach us" mdxType="Contact" />
    <ConferencesComponent title="Meet us" mdxType="ConferencesComponent" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      